<template lang="pug">
.tournamet-floating-nav(:class="{ 'parlay': betparlayCount > 0 }")
  template(v-if="whiteLabel")
    router-link.home(to="/tournament")
      img.open(src="/images/icon-other/tournament-floating-icon.png?v=12")
  template(v-else)
    router-link.home(to="/tournament" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
      img.open(src="/images/icon-other/tournament-floating-icon.png?v=12")
//-   a.home(href='#')
//-     img.open(src='images/floating_home.png')
//-     img.close(src='images/floating_close.svg')
//-   a.item.euro(href="javascript:void(0);" @click="setMenu0('event', '3', 'today')")
//-     img.img-fluid(src='images/floating_worldcup22.png')
//-     .floating-text {{ $t("ui.worldcup") }}
//-   //- a.item.copa(href="javascript:void(0);" @click="setMenu0('event', '1')")
//-   //-   img.img-fluid(src='images/floating_copa.png')
//-   a.item.community(href="javascript:void(0);")
//-     img.img-fluid#community(src='images/floating_community.svg')
//-     .floating-text {{ $t("ui.newsinfo") }} 
//- .floating-nav(:class="{ 'parlay': betparlayCount > 0 }")
//-   a.home(href='#')
//-     img.open(src='images/euro24-floating-icon.gif')
//-     img.close(src='images/floating_close.svg')
//-   a.item.euro(href="javascript:void(0);" @click='setMenu0("event", "2", getEventDate("2024-06-14T21:00:00"))')
//-     img.img-fluid(src='images/euro24-floating-icon.png')
//-   a.item.community(href='#')
//-     img.img-fluid#community(src='images/euro24-floating-icon-news.png')
  //- router-link.item(to="/tournament" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
  //-   img.img-fluid.open(src="/images/icon-other/tournament-floating-icon.png?v=12")
</template>

<script>
import config from "@/config";
import { EventBus } from "@/library/_event-bus.js";

export default {
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    menuList() {
      return this.$store.state.layout.menuList;
    },
    menuY() {
      return this.$store.state.layout.menuY;
    },
    menuX() {
      return this.$store.getters.menuX;
    },
    menu0() {
      return this.$store.getters.menu0;
    },
    menu1() {
      return this.$store.getters.menu1;
    },
    menu2() {
      return this.$store.getters.menu2;
    },
    menu3() {
      return this.$store.getters.menu3;
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    betparlayCount() {
      if(this.menuX && this.mmoMode) {
        return Object.keys(this.$store.state.betparlaymmo.data).length;
      } else {
        return Object.keys(this.$store.state.betparlay.data).length;
      }
    }
  },
  mounted() {
    var tl = new TimelineMax({
      paused: true
    }),
    tlback = new TimelineMax({
      paused: true
    }),
    intro = new TimelineMax();

    intro
      .from('.phone', 1, {
          autoAlpha: 0
      })
      .from('.hello', 0.5, {
          autoAlpha: 0
      }, 0.5)

    tl
      .to('.hello', 0.3, {
        autoAlpha: 0
      })
      .set('.home', {
        className: '+=active'
      })
      .set('.item', {
        scale: 1
      }) // fix for a bug when on of the item was appearing at 0.5 scale
      .to('.home', 0.1, {
        scale: 1.2,
        yoyo: true,
        repeat: 1
      })
      .to('.home', 0.3, {
        x: -20,
        y: -20,
        ease: Elastic.easeOut.config(1, 0.5)
      }, 0)
      .staggerFrom('.item', 0.7, {
        right: 20,
        bottom: 20,
        autoAlpha: 0,
        scale: 0.5,
        ease: Elastic.easeOut.config(1, 0.5)
      }, 0.1);

    tlback
      .set('.home', {
        className: '-=active'
      })
      .staggerTo('.item', 0.7, {
        right: 20,
        bottom: 20,
        autoAlpha: 0,
        scale: 0.5,
        ease: Elastic.easeOut.config(1, 0.5)
      }, 0.1)
      .to('.hello', 0.3, {
        autoAlpha: 1
      })
      .to('.home', 0.3, {
        x: 0,
        y: 0,
        ease: Power2.easeOut
      }, 0.5);

    $(document).on('click', '.home:not(.active)', function (event) {
      event.preventDefault();
      // tl.play(0);
    });

    $(document).on('click', '.home.active, .item', function (event) {
      if(event.target.id && event.target.id == "community"){
        window.open(config.getEuroPageUrl(), '_blank');
      }
      event.preventDefault();
      TweenMax.to($(this), 0.1, {
        scale: 1.2,
        yoyo: true,
        repeat: 1,
        onComplete: function () {
          tlback.play(0)
        }
      });
    });

    EventBus.setMenu0 = this.setMenu0;
  },
  methods: {
    clearSearch() {
      this.$store.dispatch("layout/setSearch", null);
    },
    setDays(e, m) {
      if ([1, 20, 40, 41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53].includes(e)) {
        m == "today" ? this.$store.dispatch("layout/setSelectedDays", "1") : this.$store.dispatch("layout/setSelectedDays", "0");
      } else {
        this.$store.dispatch("layout/setSelectedDays", "0");
      }
    },
    resetSelectLeague() {
      var elem = $(".btn-collapse");
      if (elem.hasClass("close-all")) {
        elem.removeClass("close-all");
        elem.addClass("open-all");
      }
      this.$store.dispatch("layout/resetSelectLeague");
    },
    getMenu(e) {
      if (!this.menuList) {
        return {};
      }

      if (!this.menuList.menu) {
        return {};
      }

      switch (e) {
        case "early":
          if (this.menuList.menu["1"]) return this.menuList.menu["1"];
          else return {};
        case "today":
          if (this.menuList.menu["2"]) return this.menuList.menu["2"];
          else return {};
        case "live":
          if (this.menuList.menu["3"]) return this.menuList.menu["3"];
          else return {};
        case "parlay":
          if (this.menuList.menu["4"]) return this.menuList.menu["4"];
          else return {};
        default:
          return {};
      }
    },
    setMenu0(e, menuY, m, bt) {
      this.$store.dispatch("layout/setSelectedMatch", null);

      var mi5 = {};
      mi5["menuX"] = false;
      if (EventBus.cancelParlay) EventBus.cancelParlay();
      if (EventBus.cancelParlayMMO) EventBus.cancelParlayMMO();
      this.$store.dispatch("layout/setOptions", { property: "parlay", value: "" });
      $(".btn-parlay").removeClass("active");
      $(".btn-mmo-parlay").removeClass("active");

      if (menuY) {
        mi5["menuY"] = menuY.toString();
      } else {
        mi5["menuY"] = "0";
      }

      // mi5["menu1"] = e;
      mi5["menu2"] = this.menu2;
      switch (e) {
        case "live":
          mi5["menu0"] = "live";
          mi5["menu3"] = "hdpou";
          var newLive = {};
          newLive[parseInt(this.menu2)] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: newLive });
          break;
        case "mmoparlay":
          mi5["menu0"] = "parlay";
          mi5["menu3"] = "parlay";
          break;
        case "event":
          mi5["menu0"] = "event";
          mi5["menu1"] = m == null ? "today" : m;
          mi5["menu3"] = bt == null ? "hdpou" : bt;
          break;
        default:
          var menu = this.getMenu(e);
          var sports = Object.keys(menu);
          var choosenSport = "1";
          if (this.menu2 != null) {
            choosenSport = this.menu2.toString();
          }
          if (!sports.includes(choosenSport)) {
            choosenSport = sports[0];
          }
          mi5["menu0"] = "all";
          mi5["menu2"] = parseInt(choosenSport);
          mi5["menu3"] = "hdpou";
          break;
      }

      var changed = true;
      if (mi5["menuX"] != this.menuX) {
        changed = true;
      }
      if (mi5["menuY"] != this.menuY) {
        changed = true;
      }
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }
      if (changed) {
        this.setDays(parseInt(mi5["menu2"]), mi5["menu1"]);
        this.resetSelectLeague();
        this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
        if(this.$route.path != '/prematch') {
          this.$router.push("/prematch").catch(err => {});
        }
      }
    },
    getEventDate(e) {
      var d1 = new Date();
      var d2 = new Date(e);
      return d1 >= d2 ? "today" : "early";
    },
    getEventDate2(e) {
      var d1 = new Date();
      var d2 = new Date(e);
      return d1 >= d2 ? null : "orz";
    },
  }
};
</script>